import React, { useEffect, useState } from "react";
import Button from "../button";
import { Link } from "react-router-dom";
import axios from "../../API/axios";
import CompanyInteraction from "../../khojpages/FollowedCompanies/CompanyInteraction";
import toast from "react-hot-toast";
import moment from "moment";
import WorkSharpIcon from '@mui/icons-material/WorkSharp';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';





function Employer() {

	const token = localStorage.getItem('token')
	const sessionId = localStorage.getItem("sessionId");


	// ...............................All company List.......................................
	const [isLoading, setIsLoading] = useState(true);
	const [companyList, setCompanyList] = useState([]);

	const getCompanyList = (page = 1) => {
		const data = {
			pageNumber: page,
			pageSize: 10,
		};

		axios
			.get(`/Company/TopCompanies?CompType=Company`, data)
			.then((response) => {
				const res = response.data.responseData;
				// console.log("company list====>", response.data.responseData);

				setCompanyList(res)
				setIsLoading(false);

			})
			.catch((error) => {
				console.log("error", error)
			});
	};

	useEffect(() => {
		getCompanyList(); // Initial fetch on mount
	}, []);

	// ...............................All company List.......................................

	//************************ Follow Company Start  ************************//

	const FollowCompany = async (id) => {
		const data = {
			sessionId: sessionId,
			compUID: id,
		};
		// console.log("session ids",sessionId ,  Compuid);

		try {
			await axios.post("/CandidateAction/FollowCompany", data)
				.then((resData) => {
					console.log("followed", resData.data.message);

					toast.success(resData.data.message)
					console.log("following ");

				});
		} catch (e) {
			if (e.response && e.response.status === 404) {
				toast.error(e.response.data.message);
			} else {
				toast.error(e.response.data.message);
			}
		}
	};
	//************************ Follow Company End  ************************//


	return (
		<>
			{companyList.length === 0 ? '' : (

				<section className="company">
					<div className="container">
						<div className="wd-employer">
							<div className="tf-title">
								<div className="group-title">
									<h1>Top Companies</h1>
									<p>Showing companies based on reviews and recent job openings</p>
								</div>
								<Link to={"/Companies"} style={{ color: '#feaa00' }} className="f-600">
									All Companies<Button className='mt-2' link="/Companies" />
								</Link>
								{/* <Button >All Companies</Button> */}
							</div>
							<div className="row wow fadeInUp ">
								{companyList?.map((data) => (
									console.log('employer', data),

									<div key={data.id} className="col-xl-6 col-12 col-md-6 col-sm-12 mb-3">
										{
											data.compType === "Company" ? (
												// <Link to={`/Company/${data.uid}`}>
												<div className="employer-block features-job">

													<div className="inner-box align-items-start">
														<div className="logo-company">
															<img src={data.logoImage} alt="User Logo" />
														</div>
														<div className="box-content">

															<h3 className="mb-0 d-flex justify-content-between">
																{
																	data.compType === "Company" ? (
																		<Link to={`/Company/${data.uid}`}>{data.name} </Link>
																	) : (
																		<>
																			<Link to={`/Recruiter/${data.uid}`}>{data.name}
																				<span className="rec-badge-purple ms-2">{data.compType}</span>
																			</Link>
																		</>
																	)
																}


															</h3>
															<div className="d-flex">

																<p className="info mb-0">
																	{data.cityName === null ? '' : <>
																		<span className="icon-map-pin me-2"></span>{data.cityName}</>
																	}
																</p>
																<p className="info mb-0 ms-3">
																	{data.startedDate === null ? '' : <>
																		<span className="icon-calendar me-2"></span>
																		&nbsp;
																		{moment.utc(data.startedDate).local().format("DD MMMM YYYY")}
																	</>
																	}
																</p>
															</div>
															<div className="d-flex ">
																{data.totalJobs === null ? '' : (
																	<>
																		<p className="info f-14 mb-0 d-flex align-center  ">
																			<WorkSharpIcon className="f-14  me-2" />
																			{data.totalJobs}  Jobs</p>
																	</>
																)}
																{data.totalFollowers === null ? '' : (
																	<>
																		<p className="info mb-0 d-flex align-center ms-3">
																			<AccountCircleSharpIcon className="f-16  me-2" />
																			{data.totalFollowers}  Followers
																		</p>
																	</>
																)}

															</div>

														</div>
														{token === null ? "" :
															<div
																onClick={(e) => {
																	e.preventDefault();
																	e.stopPropagation();
																}}
															>
																<CompanyInteraction
																	getCompanyList={getCompanyList}
																	Compuid={data.uid}
																	isBlocked={data.isBlocked} isFollowed={data.isFollowed} />
															</div>
														}

													</div>
													<div className="job-archive-footer">
														<div className="job-footer-left border-0 " >
															<ul className="job-tag Job-Footer-Small-Button mb-0">
																{data.companyCategory === null || data.companyCategory === "" ? "" : (
																	<li>
																		<Link to="#/" style={{ pointerEvents: "none" }}
																			onClick={(e) => e.preventDefault()} // Prevents navigation
																		>{data.companyCategory}</Link>
																	</li>
																)}
																{data.companySize === null || data.companySize === "" ? "" : (
																	<li>
																		<Link to="#/" style={{ pointerEvents: "none" }}
																			onClick={(e) => e.preventDefault()} // Prevents navigation
																		>{data.companySize}</Link>
																	</li>
																)}
																{data.industry === null || data.industry === "" ? "" : (
																	<li>
																		<Link to="#/" style={{ pointerEvents: "none" }}
																			onClick={(e) => e.preventDefault()} // Prevents navigation
																		>{data.industry}</Link>
																	</li>
																)}
															</ul>
														</div>

													</div>
												</div>
												// </Link>
											) : (
												<>
													<Link to={`/Recruiter/${data.uid}`}>
														<div className="employer-block features-job">

															<div className="inner-box align-items-start">
																<div className="logo-company">
																	<img src={data.logoImage} alt="User Logo" />
																</div>
																<div className="box-content">

																	<h3 className="mb-0 d-flex justify-content-between">
																		{
																			data.compType === "Company" ? (
																				<Link to={`/Company/${data.uid}`}>{data.name} </Link>
																			) : (
																				<>
																					<Link to={`/Recruiter/${data.uid}`}>{data.name}
																						<span className="rec-badge-purple ms-2">{data.compType}</span>
																					</Link>
																				</>
																			)
																		}


																	</h3>
																	<div className="d-flex">

																		<p className="info mb-0">
																			{data.cityName === null ? '' : <>
																				<span className="icon-map-pin me-2"></span>{data.cityName}</>
																			}
																		</p>
																		<p className="info mb-0 ms-3">
																			{data.startedDate === null ? '' : <>
																				<span className="icon-calendar me-2"></span>
																				&nbsp;
																				{moment.utc(data.startedDate).local().format("DD MMMM YYYY")}
																			</>
																			}
																		</p>
																	</div>
																	<div className="d-flex ">
																		{data.totalJobs === null ? '' : (
																			<>
																				<p className="info f-14 mb-0 d-flex align-center  ">
																					<WorkSharpIcon className="f-14  me-2" />
																					{data.totalJobs}  Jobs</p>
																			</>
																		)}
																		{data.totalFollowers === null ? '' : (
																			<>
																				<p className="info mb-0 d-flex align-center ms-3">
																					<AccountCircleSharpIcon className="f-16  me-2" />
																					{data.totalFollowers}  Followers
																				</p>
																			</>
																		)}

																	</div>

																</div>
																{token === null ? "" :
																	<div
																		onClick={(e) => {
																			e.preventDefault();
																			e.stopPropagation();
																		}}
																	>
																		<CompanyInteraction
																			getCompanyList={getCompanyList}
																			Compuid={data.uid}
																			isBlocked={data.isBlocked} isFollowed={data.isFollowed} />
																	</div>
																}

															</div>
															<div className="job-archive-footer">
																<div className="job-footer-left border-0 " >
																	<ul className="job-tag Job-Footer-Small-Button mb-0">
																		{data.companyCategory === null ? "" : (
																			<li>
																				<Link style={{ pointerEvents: "none" }}
																				onClick={(e) => e.preventDefault()} // Prevents navigation
																				to="#/">{data.companyCategory}</Link>
																			</li>
																		)}
																		{data.companySize === null ? "" : (
																			<li>
																				<Link style={{ pointerEvents: "none" }}
																				onClick={(e) => e.preventDefault()} // Prevents navigation
																				 to="#/">{data.companySize}</Link>
																			</li>
																		)}
																		{data.industry === null ? "" : (
																			<li>
																				<Link style={{ pointerEvents: "none" }}
																				onClick={(e) => e.preventDefault()} // Prevents navigation
																				 to="#/">{data.industry}</Link>
																			</li>
																		)}
																	</ul>
																</div>

															</div>
														</div>
													</Link>
												</>
											)
										}

									</div>
								))}
							</div>
						</div>
					</div>
				</section>
			)}
		</>
	);
}

export default Employer;
